App.DishGroup = DS.Model.extend
  main_locale: DS.attr 'string'  
  organization_id: DS.attr 'number'  
  visible: DS.attr 'boolean'  
  name: DS.attr 'string'  
  min: DS.attr 'number'  
  max: DS.attr 'number'  
  view_type: DS.attr 'string'  
  external_id: DS.attr 'string'
  dish_ids: DS.attr 'mixed'
  dishes: DS.attr 'mixed', defaultValue: []

  organization: DS.belongsTo 'organization', async: true
